export default {
    // 支付订单
    payOrder: () => import( /* webpackChunkName: "payOrder" */ '../../views/YT/payOrder.vue'),
    // 支付成功
    paySucceed: () => import( /* webpackChunkName: "paySucceed" */ '../../views/YT/paySucceed.vue'),
    // 支付失败
    payFailure: () => import( /* webpackChunkName: "payFailure" */ '../../views/YT/payFailure.vue'),
    // IOS不支持
    payNoSupport: () => import( /* webpackChunkName: "payNoSupport" */ '../../views/YT/noSupport.vue'),
	// 云信流转图
	circulationImg:() => import( /* webpackChunkName: "circulationImg" */ '../../views/YT/cloudLetter/circulationImg.vue'),
    // 云投H5支付备审页
    index: () => import( /* webpackChunkName: "payNoSupport" */ '../../views/YT/index.vue'),
    // 云投会员缴费
    memberPay: () => import( /* webpackChunkName: "payNoSupport" */ '../../views/YT/memberPay.vue'), 

}